import React from 'react';
import { ChatModel } from '@whelk/services/src/type/chat';
import { CheckIcon } from '../ModelSelect/icon';

// 自定义选项组件
const ModelOption = ({
  value,
  label,
  description,
  img,
  isSelected,
}: Pick<ChatModel, 'value' | 'label' | 'description' | 'img'> & {
  isSelected?: boolean;
}) => (
  <div className='hover:bg-col_bg03 relative flex min-h-[51px] items-stretch overflow-hidden rounded-[12px] p-2'>
    <div className='flex w-[18px] flex-shrink-0 items-center justify-center md:inline-block'>
      <img src={img} alt={`model-${value}`} className='h-[18px] w-[18px] object-cover' />
    </div>
    <div className='flex  flex-1 flex-col justify-center pl-[10px] pr-8'>
      <div className='mb-1 flex items-center gap-[8px]'>
        <p className='text-col_text00 text-sm font-medium'>{label}</p>
      </div>
      <p className='text-col_text01 whitespace-pre-wrap break-words text-xs'>{description}</p>
    </div>
    {isSelected && (
      <div className='absolute right-2 top-1/2 -translate-y-1/2'>
        <CheckIcon />
      </div>
    )}
  </div>
);

export default ModelOption;
